  (function ($) {
    // Attach the plugin function to the jQuery prototype
    $.fn.toggleLogo = function (options) {
      var $this = $(this);
      let $paragraphs;
      let currentIndex = 0;
      let interval;

      // Define default settings
      var settings = $.extend({
        itemSelector: ".w-logos li",
        paragraphSelector: ".w-paragraphs p",
        autoPlay: true,
        speed: 8000, //8s
        // A callback function option
        onComplete: function() {}
      }, options); // Merge defaults and user options

      // 'this' refers to the jQuery object the function was called on
      return this.each(function () {          
          // Call an internal helper function
          _init($this, settings);

          // Execute the callback function if it's provided
          settings.onComplete.call(this);
      });
    };

    // Internal helper function (optional, scoped within the IIFE)
    function _init(element, options) {
      let $element = $(element);
      let $paragraphs = $(options.paragraphSelector); 
      let $clickedItem = $(options.itemSelector);
      // Click event on logo
      $clickedItem.on("click", function () {
        let index = $clickedItem.index(this);
        showLogo(index);
        if(options.autoPlay == true){
          startAutoplay(); // reset timer
        }
      }); 
      function showLogo(index) {
        let $activeLogo = $clickedItem.eq(index);
        let content = $activeLogo.find("p").html();
             
        $clickedItem.removeClass("active");
        $activeLogo.addClass("active");

        // Show correct paragraph
        $paragraphs.html(content);
        $paragraphs.show();
        
        currentIndex = index;
      }

      function startAutoplay() {
        clearInterval(interval);
        interval = setInterval(function () {
          currentIndex = (currentIndex + 1) % $clickedItem.length;
          showLogo(currentIndex);
        }, options.speed); 
      }

      showLogo(0);
      if(options.autoPlay == true){
        startAutoplay(); 
      }  
      
    }
  })(jQuery);
  
  